import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import {NgSelectizeModule} from 'ng-selectize';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CryptoBalancesComponent } from './crypto-balances.component';
import { MyChartPieModule } from '@bt/shared/charts/chart-pie/chart-pie.module';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      SharedModule,
      NgSelectizeModule,
      FontAwesomeModule,
      MyChartPieModule
    ],
    declarations: [
      CryptoBalancesComponent,
    ],
  })
  export class CryptoBalancesModule { }


// WEBPACK FOOTER //
// ./src/app/crypto-balances/crypto-balances.module.ts